import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDeliveryNoteTemplatesStore } from "../../stores/delivery_note_templates";
import { useDeliveryNotesStore } from "../../stores/delivery_notes";
import { useWorkOrdersStore } from "../../stores/work_orders";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";
import MobileActionBarContent from "../../components/mobile-action-bar/MobileActionBarContent";

function Home() {
  const { t } = useTranslation();
  const [templatesByIds, templatesAllIds, fetchSomeTemplates] =
    useDeliveryNoteTemplatesStore(
      (state) => [state.byIds, state.allIds, state.fetchSome],
      shallow,
    );

  const [totalDraft, fetchDraftTotal] = useDeliveryNotesStore(
    (state) => [state.totalDraft, state.fetchDraftTotal],
    shallow,
  );

  const [totalOpenWorkOrders, fetchOpenWorkOrderTotal] = useWorkOrdersStore(
    (state) => [state.totalOpen, state.fetchOpenTotal],
    shallow,
  );

  useEffect(() => {
    fetchSomeTemplates({ q: "", limit: 20, offset: 0 });
    fetchDraftTotal();
    fetchOpenWorkOrderTotal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="my-auto my-md-0 px-3 px-md-0">
        {templatesAllIds.map((sid) => (
          <Link
            key={sid}
            to={`/delivery_notes/add?templateId=${sid}`}
            className="btn btn-lg btn-red w-100 mb-2 min-h-45px"
          >
            {t("delivery_notes.delivery_note")} {templatesByIds[sid].name}
          </Link>
        ))}
      </div>
      <MobileActionBarContent>
        <div className="d-flex gap-2 w-100">
          <Link to="/work_orders?filter=open" className="btn btn-default flex-fill">
            {t("work_orders.work_orders")}
            {totalOpenWorkOrders > 0 && (
              <span className="badge bg-red ms-2">{totalOpenWorkOrders}</span>
            )}
          </Link>
          <Link to="/delivery_notes?filter=draft" className="btn btn-default flex-fill">
            {t("menu.drafts")}
            {totalDraft > 0 && (
              <span className="badge bg-red ms-2">{totalDraft}</span>
            )}
          </Link>
        </div>
      </MobileActionBarContent>
    </div>
  );
}

export default Home;
